import * as React from 'react';
import { useState, CSSProperties, useRef } from 'react';
import { Range, getTrackBackground, useThumbOverlap } from 'react-range';


const COLORS = ['#0C2960', '#276EF1', '#9CBCF8', '#ccc'];
const THUMB_SIZE = 20;


export default function App({STEP, MIN, MAX, values, setValues, type}) {

  return (
    <div
      style={{
        padding: '10px',
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap'
      }}
  > 
    <Range
      //  ref={rangeRef}
      onFinalChange={(e) => {


      }}
      
      values={values}
      step={STEP}
      min={MIN}
      max={MAX}
      rtl={false}
      onChange={(values) => setValues(values)}
      renderMark={({ props, index, }) => (
        <div
          {...props}
          style={{
            ...props.style,
            height: '16px',
            width: '5px',
            backgroundColor: index * STEP < values[0] ? '#548BF4' : '#ccc'
          }}
        />
      )}
      renderTrack={({ props, children }) => {
         
        return(
        <div
          onMouseDown={props.onMouseDown}
          onTouchStart={props.onTouchStart}
          style={{
            ...props.style,
            height: '36px',
            display: 'flex',
            width: '100%'
          }}
        >
          <div
            ref={props.ref}
            style={{
              height: '5px',
              width: '100%',
              borderRadius: '4px',
              background: getTrackBackground({
                values: values,
                colors: COLORS,
                min: MIN,
                max: MAX,
                rtl: false
              }),
              alignSelf: 'center'
            }}
          >
            {children}
          </div>
        </div>
      )}}
      renderThumb={({ props, isDragged, index, value }) => {
      
        props.style['cursor'] = index !== 1 && 'not-allowed';
        return(
        <div
        aria-disabled
          {...props}
          style={{
            ...props.style,
            height: `${THUMB_SIZE}px`,
            width: `${THUMB_SIZE}px`,
            borderRadius: '4px',
            backgroundColor: '#FFF',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0px 2px 6px #AAA'
          }}
        >
          
        
                 <div
              style={{
                position: 'absolute',
                top: '-28px',
                color: '#fff',
                fontWeight: 'bold',
                fontSize: '14px',
                fontFamily: 'Arial,Helvetica Neue,Helvetica,sans-serif',
                padding: '4px',
                borderRadius: '4px',
                backgroundColor: '#548BF4'
              }}
            >
             {values[index].toFixed(0)}
            </div>
          <div
            style={{
              height: '16px',
              width: '5px',
              backgroundColor: isDragged ? '#548BF4' : '#CCC'
            }}
          />
        </div>
      )}}
    />
      <output style={{ marginTop: '15px' }} id="output">
     {values[1].toFixed(0)} {type}
      </output>
  </div>
  )
}
